import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { ContactInfoRow } from '@/features/employees/components/contact/ContactInfoRow';

const inputClasses =
  'py-1.5 px-2 border block w-full bg-field border-border rounded-sm text-sm text-onfield placeholder:text-onfield/30 focus:z-10 focus:border-primary focus:ring-primary focus:outline-none disabled:opacity-50 disabled:pointer-events-none';

export interface UserFormData {
  username: string;
  phoneNumber: string;
}

interface UserInfoSectionProps {
  email: string;
  formData: UserFormData;
  isEditMode: boolean;
  onFieldChange: <K extends keyof UserFormData>(field: K, value: UserFormData[K]) => void;
  languageField?: ReactNode;
}

export function UserInfoSection({
  email,
  formData,
  isEditMode,
  onFieldChange,
  languageField,
}: UserInfoSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="divide-y divide-border">
      <ContactInfoRow label={t('userProfile.fields.email')}>
        <span>{email}</span>
      </ContactInfoRow>

      <ContactInfoRow label={t('userProfile.fields.username')}>
        {isEditMode ? (
          <input
            type="text"
            value={formData.username}
            onChange={(e) => onFieldChange('username', e.target.value)}
            placeholder={t('userProfile.placeholders.username')}
            className={inputClasses}
          />
        ) : (
          <span>{formData.username || '-'}</span>
        )}
      </ContactInfoRow>

      <ContactInfoRow label={t('userProfile.fields.phoneNumber')}>
        {isEditMode ? (
          <input
            type="tel"
            value={formData.phoneNumber}
            onChange={(e) => onFieldChange('phoneNumber', e.target.value)}
            placeholder={t('userProfile.placeholders.phoneNumber')}
            className={inputClasses}
          />
        ) : (
          <span>{formData.phoneNumber || '-'}</span>
        )}
      </ContactInfoRow>

      {languageField && (
        <ContactInfoRow label={t('userProfile.fields.language')}>
          {languageField}
        </ContactInfoRow>
      )}
    </div>
  );
}
